// extracted by mini-css-extract-plugin
export default {"control":"ScheduledRemindersPanel_control__naj2K","rowContent":"ScheduledRemindersPanel_rowContent__EUKt8"};